import AppData from '../../../../Model/AppData'

const DEFAULT_DELIVERY_PROCESSING_FEE = 0
const DEFAULT_DELIVERY_COST_MERCHANT_COVER = 0

const getDeliverySettingValue = (key, defaultValue) => {
    let value = AppData.data.getMerchantSettingValue(key)
    if (value == null || value == '') {
        return defaultValue
    }
    return parseFloat(value) || 0   // Return 0 if unable to parse value
}

export default class DeliveryPriceCalculator {
    static get DEFAULT_DELIVERY_PROCESSING_FEE() {
        return DEFAULT_DELIVERY_PROCESSING_FEE
    }
    static get DEFAULT_DELIVERY_COST_MERCHANT_COVER() {
        return DEFAULT_DELIVERY_COST_MERCHANT_COVER
    }
    static getDeliveryRates = () => {
        if (AppData.data.getMerchantSettingValue('is_allow_merchant_use_own_delivery_team')) {
            let deliveryRates = AppData.data.getMerchantSettingValue('delivery_rates')
            if (deliveryRates) {
                return JSON.parse(deliveryRates)
            }
        }
        return []
    }
    static calculatePrice = (distanceData) => {
        let distance = 0
        let duration = 0
        let price = 0
        let basePrice = 0
        let merchantCoverFee = DEFAULT_DELIVERY_COST_MERCHANT_COVER
        let processingFee = DEFAULT_DELIVERY_PROCESSING_FEE

        let distance_text = '--'
        let duration_text  = '--'
        let price_text = '--'

        let too_far = false
        let free_delivery = false
        if (distanceData.distance) {
            let km = (distanceData.distance || 0) / 1000

            let maxKm = 10
            let minKm = 5
            let minKmPrice = 5
            let perKmPrice = 1

            minKm = getDeliverySettingValue('delivery_minimum_charge_distance', minKm)
            minKmPrice = getDeliverySettingValue('delivery_minimum_charge', minKmPrice)
            perKmPrice = getDeliverySettingValue('delivery_extra_charge_per_km', perKmPrice)
            maxKm = getDeliverySettingValue('delivery_maximum_distance', maxKm)
            merchantCoverFee = getDeliverySettingValue('delivery_cost_merchant_cover', merchantCoverFee)
            processingFee = getDeliverySettingValue('delivery_processing_fee', processingFee)

            let deliveryRate = this.getDeliveryRates().find(dr => {
                // Return the first item that has distance less than measure distance
                // Say distance = 12
                // 0 - 5
                // 5 - 10
                // 10 - N    <--- find this, if N > 12
                // N - null  <--- Or this, if N < 12
                return dr.till > km || dr.till == null
            })

            // Override some of the delivery_* settings if has define deliveryRates array
            if (deliveryRate) {
                minKm = deliveryRate.from
                minKmPrice = deliveryRate.base_price
                perKmPrice = deliveryRate.rate_per_km
            }

            let baseCharge = minKmPrice
            let extraKm = Math.round(km - minKm).toFixed(0)
            let extraKmPrice = extraKm > 0 ? extraKm * perKmPrice : 0

            // RM 1 Profit
            basePrice = baseCharge + extraKmPrice
            price = basePrice + processingFee - merchantCoverFee
            price = price < 0 ? 0 : price

            price_text = km >= maxKm? lang.too_far : price > 0 ? "≈ "+AppData.data.currencyName+" " + (price).toFixed(2) : lang.free_delivery// + " - " + priceMax.toFixed(0)
            distance = (Math.round(km)).toFixed(0)

            if(km < minKm){
                distance_text = "<" + minKm + " km"
            }
            else{
                distance_text = distance + " km"
            }
            duration = Math.ceil(distanceData.duration / 60)
            duration_text = Math.ceil(distanceData.duration / 60) + " minutes"

            too_far = km >= maxKm? true : false
            free_delivery = price > 0 ? false : true;
        }

        return {
            price_text, price, distance, distance_text, duration, duration_text, basePrice, merchantCoverFee, processingFee, too_far, free_delivery
        }
    }
}